import { ReduxState, TelematicProviderType } from 'types';
import { connect } from 'react-redux';
import { getTelematicDisplayName } from 'screens/vehicles-import/TableInvalidLicensePlates';


export const ConnectionRenderer = (props: Props) => (
    <span className={`connection-${props.connection}`}>
        {getTelematicDisplayName(props.connection, props.telematicTypeMetadata)}
    </span>
)

type OwnProps = {
    connection: TelematicProviderType
}
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps & OwnProps;

function mapStateToProps(state: ReduxState) {
    return {
        telematicTypeMetadata: state.companyDetails.telematicTypeMetadata
    };
}

export default connect(mapStateToProps, null)(ConnectionRenderer);